/** @jsx jsx */
import { jsx } from '@emotion/core'

import { media } from '../../../constants'
import MobileScreen from './MobileScreen'

export default ({ items, showChrome }) => {
	return (
		<div
			data-comp="workshowcase-mobile-3up"
			css={{
				width: '100%',
				maxWidth: '70rem',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',

				'& > * + *': {
					marginLeft: '3rem',
					[media.small]: {
						marginLeft: 0,
					},
				},

				[media.small]: {
					flexWrap: 'wrap',
				},
			}}
		>
			{items.slice(0, 3).map(({ src, alt }, idx) => (
				<div
					key={idx}
					css={{
						flex: 1,

						[media.small]: {
							flexBasis: '50%',
							maxWidth: '50%',
							padding: '0.5rem', // space between on mobile
						},
					}}
				>
					<MobileScreen key={idx} src={src} alt={alt} showChrome={showChrome} />
				</div>
			))}
		</div>
	)
}
